
import { getDateSuffix } from "~/utils/locale";
import processDateAvailable from "~/mixin/process-date-available-mixin";
import OccasionsMixin from "~/mixin/occasions-fetch-mixin";

export default {
  name: "cal-sub6-frequency",
  mixins: [processDateAvailable, OccasionsMixin],
  data() {
    return {
      activeIndex: [],
      weekFrequency: 0,
      selectedDate: "",
      nextAvailableDate: "",
      maxDate: "",
      deliveryDates: { ...this.$store.state.cartItem.subsDeliveryDates },
      validationFailed: false,
      closedDays: [],
      unavailableDates: [],
      availableDates: [],
      datesUpdated: null,
      selectedFrequency: this.$store.state.cartItem.frequency || "",
      currentLocale: this.$i18n.getLocaleCookie(),
      occasions: [],
      cutoffCountdown: [],
      showError: false
    };
  },
  props: ["subscriptionTimePeriod", "showCartDialog"],
  computed: {
    subscriptionTimePeriodSelected() {
      return this.subscriptionTimePeriod || this.$store.state.cartItem.subscriptionTimePeriod;
    },
    dates() {
      return this.datesUpdated || this.$store.state.cartItem.subscriptionDates;
    },
    validDates() {
      return !this.dates.some(date => { return date.actualDate === ""; });
    }
  },
  watch: {
    dates() {
      this.showError = false;
      if (this.dates.filter((item) => { return item.actualDate === ""; }).length > 0) {
        this.$nuxt.$emit("sub6MonthFrequencyDisabled", true);
      } else {
        this.$nuxt.$emit("sub6MonthFrequencyDisabled", false);
      }
    }
  },
  async created() {
    this.onInit();
    this.maxDate = this.$dayjs().add(1, "year").format("YYYY-MM-DD");
    this.occasions = await this.getOccasions();

    this.$nuxt.$on("updatedSubSize", () => {
      this.deliveryDates = { ...this.$store.state.cartItem.subsDeliveryDates };
      this.selectedFrequency = this.$store.state.cartItem.frequency || 0;
      this.updateProductfor6MonthSub()
    });

    this.$nuxt.$on("productSelected", () => {
      this.deliveryDates = { ...this.$store.state.cartItem.subsDeliveryDates };
      this.selectedFrequency = this.$store.state.cartItem.frequency || 0;
      this.initDeliveryDates();
      this.updateProductfor6MonthSub()
    });

    this.$nuxt.$on("deliveryDateUpdated", () => {
      this.initDeliveryDates();
      this.validationFailed = false;
    });

    this.$nuxt.$on("cityUpdated", async () => {
      await this.getCutoffs();
      this.initDeliveryDates();
    });

    this.$nuxt.$on("scrollToSub6Frequency", () => {
      const Sub6FrequencyEl = document.getElementById('sub6-frequency');
      if (Sub6FrequencyEl) {
        Sub6FrequencyEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    this.$nuxt.$on("runInputFieldsValidation", () => {
      if (!this.validDates) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    })

  },
  methods: {
    async onInit() {
      if (this.subscriptionTimePeriod) {
        this.$store.dispatch("cartItem/SUBS_TIME_PERIOD_SET", this.subscriptionTimePeriod);
      }

      if (JSON.stringify(this.deliveryDates) !== "{}") {
        this.$nuxt.$emit("sub6MonthFrequencyDisabled", false);
      }

      this.selectedFrequency = this.$store.state.cartItem.frequency || "";
      this.initDeliveryDates();
      this.updateProductfor6MonthSub()
    },
    updateProductfor6MonthSub() {
      if (
        this.$store.state.cartItem.subscriptionProd?.variants &&
        this.$store.state.cartItem.subscriptionProd?.variants.length > 0 &&
        this.$store.state.cartItem.selectedSubscription?.variantType.length > 0
      ){
        let mappedVariant =
          this.$store.state.cartItem.subscriptionProd.variants.find(
            (variant) =>
              variant.displayTitle.includes(
                this.$store.state.cartItem.selectedSubscription.variantType
              ) &&
              variant.displayTitle.includes(
                this.$store.state.cartItem.selectedSubscription.collectionType
              ) &&
              variant.displayTitle.includes(
                this.subscriptionTimePeriodSelected.toString()
              )
          );
        this.$store.dispatch("cartItem/PRODUCT_SET", {
          product: {...mappedVariant},
          locale: this.$store.state.cartItem.locale,
          deliveryTown: this.$store.state.cartItem.deliveryTown,
          id: this.$store.state.cartItem.id,
        });
      }
    },
    calanderExpansion(index) {
      if (this.activeIndex.indexOf(index) > -1) {
        this.activeIndex.splice(this.activeIndex.indexOf(index), 1);
      } else {
        this.activeIndex.push(index);
      }
    },
    getDateSuffix(index) {
      return getDateSuffix(this.$i18n.locale, index, false);
    },
    copyDatesFromStore() {
      const dates = [];
      for (const item of this.dates) {
        dates.push({ ...item });
      }
      return dates;
    },
    updateCalanderDates(selectedDate, index) {
      this.validationFailed = false;
      const dateObj = this.copyDatesFromStore();
      dateObj[index]["actualDate"] = selectedDate;
      if (index === 0) {
        this.$store.dispatch("cartItem/UPDATE_DELIVERY_DATE", selectedDate);
      }
      this.selectedFrequency = "";

      for (let i = index; i < this.subscriptionTimePeriodSelected; i++) {

        if (i === index) {
          dateObj[i]["actualDate"] = selectedDate;
        } else {
          dateObj[i]["actualDate"] = "";
          dateObj[i]["startDate"] = this.$dayjs(
            (dateObj[i - 1]["actualDate"] === "") ? dateObj[i - 1]["startDate"] : dateObj[i - 1]["actualDate"])
            .add(1, "day")
            .format("YYYY-MM-DD");;
        }

        i > 0 && i < this.subscriptionTimePeriodSelected
          ? this.deliveryDates[`DELIVERY_DATE-${i + 1}`] = dateObj[i]["actualDate"]
          : this.deliveryDates["DELIVERY_DATE"] = dateObj[0]["actualDate"]
      }
      //TODO : repete sdame logic in create
      if (dateObj.filter((item) => { return item.actualDate === ""; }).length > 0) {
        this.$nuxt.$emit("sub6MonthFrequencyDisabled", true);
      } else {
        this.$nuxt.$emit("sub6MonthFrequencyDisabled", false);
        this.$store.dispatch("cartItem/SUBS_DELIVERY_DATES_ADD", {
          ...this.deliveryDates,
        });
      }

      this.$store.dispatch("cartItem/SUBS_DATES_SET", dateObj);
      this.calanderExpansion(index);
    },
    frequencyChangeCalendar(selectedFrequency) {
      if (this.validDates) return;
      const dates = [...this.dates];
      for (let i = 1; i < this.subscriptionTimePeriodSelected; i++) {
        let dateObj = new Object();
        dateObj["actualDate"] = i === 0 ? this.$store.state.cartItem.deliveryDate : this.$dayjs(dates[i - 1]["actualDate"]).add(7 * parseInt(selectedFrequency), "day").format("YYYY-MM-DD");

        while (this.unavailableDates.includes(dateObj["actualDate"])) {
          dateObj["actualDate"] = this.$dayjs(dateObj["actualDate"]).add(1, "day").format("YYYY-MM-DD");
        }

        dateObj["startDate"] = (i === 0) ? this.$dayjs().format("YYYY-MM-DD") : this.$dayjs(dates[i - 1]["actualDate"]).add(1, "day").format("YYYY-MM-DD");

        // Validate current delivery date picker selcted date with max available date
        if (!this.validateWithMaxDate(dateObj["actualDate"])) {
          dateObj["startDate"] = "";
          dateObj["actualDate"] = "";
          dateObj[`DELIVERY_DATE-${i + 1}`] = "";
          this.validationFailed = true;
          dates[i] = dateObj;

          this.$nuxt.$emit("sub6MonthFrequencyDisabled", true);
          return;
        } else {
          this.validationFailed = false;
        }

        i > 0
          ? this.deliveryDates[`DELIVERY_DATE-${i + 1}`] = dateObj["actualDate"]
          : this.deliveryDates["DELIVERY_DATE"] = dateObj["actualDate"]
        dates[i] = { ...dateObj };
      }

      this.$store.dispatch("cartItem/SUBS_DATES_SET", dates);

      this.$store.dispatch("cartItem/SUBS_DELIVERY_DATES_ADD", {
        ...this.deliveryDates,
      });
      this.$store.dispatch("cartItem/SUBS_FREQUENCY_SET", selectedFrequency);
      this.$nuxt.$emit("sub6MonthFrequencyDisabled", false);

    },
    validateWithMaxDate(date) {
      return this.$dayjs(this.maxDate).diff(this.$dayjs(date)) > 0;
    },
    checkForNewDeliveryDate() {
      let dates = [...this.dates];
      if (dates[0]["startDate"] !== this.$store.state.cartItem.deliveryDate) {
        let dateObj = new Object();
        dateObj["startDate"] = this.$store.state.cartItem.deliveryDate;
        dateObj["actualDate"] = this.$store.state.cartItem.deliveryDate;
        // trigger when update the object or array
        dates[0] = { ...dateObj };
        dates = dates.splice(0);
      }
      this.$store.dispatch("cartItem/SUBS_DATES_SET", dates);
    },
    checkActualDateIsSet(dates, index) {
      return dates[index] && dates[index]['actualDate'];
    },
    initDeliveryDates() {
      this.$nuxt.$emit("sub6MonthFrequencyDisabled", false); // make it false due ti a issue in subs edit TODO: need perment fix
      this.nextAvailableDate = sessionStorage.deliveryDate;
      this.deliveryDates = { ...this.$store.state.cartItem.subsDeliveryDates };

      const dates = [...this.dates];
      for (let i = 0; i < this.subscriptionTimePeriodSelected; i++) {

        if (this.checkActualDateIsSet(dates, i)) {
          continue;
        }

        let dateObj = new Object();
        if (i > 0) {
          dateObj["startDate"] = this.$dayjs((dates[i - 1]["actualDate"] === "" || !dates[i - 1]["actualDate"]) ? dates[i - 1]["startDate"] : dates[i - 1]["actualDate"])
            .add(1, "day")
            .format("YYYY-MM-DD");

          dateObj["actualDate"] = "";
        } else {
          dateObj["startDate"] = this.$dayjs().format("YYYY-MM-DD");
          dateObj["actualDate"] = "";
        }

        dates[i] = { ...dateObj };

        i > 0
          ? (this.deliveryDates[`DELIVERY_DATE-${i + 1}`] =
            dateObj["actualDate"])
          : (this.deliveryDates[`DELIVERY_DATE`] =
            sessionStorage.deliveryDate);
      }

      if (!this.checkActualDateIsSet(dates, 0)) {
        dates[0]["actualDate"] = sessionStorage.deliveryDate;
      }

      this.$store.dispatch("cartItem/SUBS_DATES_SET", dates);
    },
   async getCutoffs() {
      try {
        this.cutoffs = await this.$axios.$get(
          `v3/region/cutoff/${JSON.parse(
            sessionStorage.deliveryTown
          ).regionTag.toLowerCase()}`,
          {
            headers: {
              "callia-lang": this.$i18n.getLocaleCookie(),
            },
          }
        );

        this.closedDays = this.cutoffs.closedDates.map((closeD) => parseInt(closeD));
        const cutoffDateResponse = this.processDateRestrictions(this.cutoffs);
        this.nextAvailableDate = this.findNextAvailableDate(this.$dayjs().format(), { ...cutoffDateResponse, finalCloseDays: this.closedDays }).format("YYYY-MM-DD");

        if (this.$dayjs(this.nextAvailableDate) < this.$dayjs(this.startDate)) {
          this.nextAvailableDate = this.$dayjs(this.startDate).format("YYYY-MM-DD");
        }

        this.closedDays = this.closedDays;
        this.unavailableDates = cutoffDateResponse.finalUnavailableDates;
        this.availableDates = cutoffDateResponse.finalAvailableDates;
        this.cutoffCountdown = this.cutoffs.cutoff_countdown
        if (this.setNxtAvailableDate && !sessionStorage.deliveryDate) {
          sessionStorage.deliveryDate = this.nextAvailableDate;
          this.dateChangeDesktop(this.nextAvailableDate);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  async fetch() {
    await this.getCutoffs();
  }
};
